import { useEffect, useState } from 'react';
import { TextareaAutosize } from '@material-ui/core';

const WrappedTextareaAutosize = ({ disabled, dataCy, className, margin, id, value, minRows, maxRows, name, onChange, onBlur, onKeyDown }) => {
  const [localState, setLocalState] = useState()

  useEffect(() => {
    setLocalState(value)
  }, [value])

  const handleChange = (e, submit) => {
    setLocalState(e.target.value)
    onChange(e, submit)
  }

  return (
    <TextareaAutosize
      disabled={disabled}
      data-cy={dataCy}
      className={className}
      margin={margin || 'dense'}
      id={id}
      value={localState || ""}
      minRows={minRows || 1}
      maxRows={maxRows || 10}
      name={name}
      onChange={(e) => handleChange(e, false)}
      onBlur={
        onBlur
          ? onBlur
          : (e) => handleChange(e, true)}
      onKeyDown={
        onKeyDown
          ? onKeyDown
          : (e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
    />
  );
}

export default WrappedTextareaAutosize;